/**
 * Loop node configuration type and validation
 */

export type LoopConfigType = {
  arrayExpression: string;
  itemVariableName: string;
  maxIterations: number;
};

export const defaultLoopConfig: LoopConfigType = {
  arrayExpression: '',
  itemVariableName: 'item',
  maxIterations: 100,
};

// Constants matching backend
export const DEFAULT_MAX_ITERATIONS = 100;
export const MAX_ALLOWED_ITERATIONS = 1000;

export const validateLoopConfig = (
  config: LoopConfigType,
): Record<string, string> => {
  const errors: Record<string, string> = {};

  if (!config.arrayExpression?.trim()) {
    errors.arrayExpression = 'Array expression is required';
  }

  if (!config.itemVariableName?.trim()) {
    errors.itemVariableName = 'Item variable name is required';
  } else if (!/^[a-zA-Z][a-zA-Z0-9_]*$/.test(config.itemVariableName)) {
    errors.itemVariableName =
      'Must start with a letter and contain only letters, numbers, or underscores';
  }

  if (
    config.maxIterations < 1 ||
    config.maxIterations > MAX_ALLOWED_ITERATIONS
  ) {
    errors.maxIterations = `Must be between 1 and ${MAX_ALLOWED_ITERATIONS}`;
  }

  return errors;
};

/**
 * Get preview text for the node display
 */
export const getLoopPreviewText = (config: LoopConfigType): string => {
  if (!config.arrayExpression) return 'Configure loop';
  return `For each ${config.itemVariableName || 'item'}`;
};
